import { cn } from '@1trading/react';
import { config, type Env } from '@/lib/env';

const ENV_LABELS: Record<Env['APP_ENV'], string> = {
  localhost: 'Local',
  development: 'Dev',
  staging: 'Staging',
  preprod: 'Preprod',
  production: 'Production',
};

interface EnvTagProps {
  className?: string;
}

/** Non-prod environment pill — shows nothing in production. Same tag everywhere it appears (top bar, sidebar) so there's one unmistakable signal, not several. */
export const EnvTag = ({ className }: EnvTagProps) => {
  if (!config.IS_NON_PROD) return null;

  return (
    <span className={cn('rounded-full border border-amber-500/40 bg-amber-500/10 px-2.5 py-0.5 text-xs font-semibold tracking-wide text-amber-500 uppercase', className)}>
      {ENV_LABELS[config.APP_ENV]}
    </span>
  );
};
EnvTag.displayName = 'EnvTag';
